import { Card, CrudMode, DataDisplay, Grid, ValidationErrors, pn, useElementBreakpoints } from "@compass/core";
import { Input } from "components";
import { User, UserEditResource, UserViewResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const BasicInfo = (props: {
  crudMode: CrudMode;
  user: User;
  setUser: (value: User) => void;
  viewResource: UserViewResource;
  editResource: UserEditResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const emailField = () => {
    var propertyName = pn<User>("email");
    var property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.user.email}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.user.email}
        onChange={(e) =>
          props.setUser(
            produce(props.user, (draft) => {
              draft.email = e.target.value;
            })
          )
        }
      />
    );
  };

  const usernameField = () => {
    var propertyName = pn<User>("username");
    var property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.user.username}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.user.username}
        onChange={(e) =>
          props.setUser(
            produce(props.user, (draft) => {
              draft.username = e.target.value;
            })
          )
        }
      />
    );
  };

  const lastNameField = () => {
    var propertyName = pn<User>("lastName");
    var property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.user.lastName}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.user.lastName}
        onChange={(e) =>
          props.setUser(
            produce(props.user, (draft) => {
              draft.lastName = e.target.value;
            })
          )
        }
      />
    );
  };

  const firstNameField = () => {
    var propertyName = pn<User>("firstName");
    var property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.user.firstName}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.user.firstName}
        onChange={(e) =>
          props.setUser(
            produce(props.user, (draft) => {
              draft.firstName = e.target.value;
            })
          )
        }
      />
    );
  };

  return (
    <Card header={"Profile"}>
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={smallFieldBreakpoints}>
          {emailField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {usernameField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {firstNameField()}
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          {lastNameField()}
        </Grid>
      </Grid>
    </Card>
  );
};
